import { ActiveAlarm, SensorStatus } from 'src/app/api/generated';
import { formatAlarmValue } from './alarm-value-formatter';

export function getAlarmLevelLabel(
  level: SensorStatus.AlarmLevelEnum
): string {
  switch (level) {
    case 'none':
      return 'Kein Alarm';
    case 'level_1':
      return 'Warnung';
    case 'level_2':
    case 'level_3':
      return 'Alarm';
  }
}

export function getAlarmLevelStatusLabel(
  level: SensorStatus.AlarmLevelEnum
): string {
  switch (level) {
    case 'none':
      return 'Kein Alarm';
    case 'level_1':
      return 'Warnung (Stufe 1)';
    case 'level_2':
      return 'Alarm (Stufe 2)';
    case 'level_3':
      return 'Alarm (Stufe 3)';
  }
}

export function getAlarmDirectionLabel(
  operator: ActiveAlarm.OperatorEnum
): string {
  return operator === '<' ? 'Unterschreitung' : 'Überschreitung';
}

export function formatAlarmDescriptor(alarm: ActiveAlarm): string {
  return `Stufe ${alarm.severity} · ${getAlarmLevelLabel(
    alarm.level
  )} · ${getAlarmDirectionLabel(alarm.operator)} (${alarm.operator})`;
}

export function formatAlarmComparison(alarm: ActiveAlarm): string {
  return `${formatAlarmValue(alarm.value)} ${alarm.operator} ${formatAlarmValue(
    alarm.threshold
  )}`;
}

export function formatMaximumSeverity(
  severity: number | null | undefined
): string {
  return severity === null || severity === undefined
    ? '—'
    : `Stufe ${severity}`;
}

export function formatSensorMapLabel(
  sensorLabel: string,
  severity: number | null | undefined
): string {
  const severityLabel = formatMaximumSeverity(severity);
  return severityLabel === '—'
    ? sensorLabel
    : `${sensorLabel} · ${severityLabel}`;
}
